import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bookingFormHolders" }
const _hoisted_2 = { class: "instructionText" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "Instructions:", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "dropBodyBlock" }, [
  /*#__PURE__*/_createElementVNode("iframe", {
    id: "bookingFormPreview",
    src: "",
    width: "80%",
    height: "100%",
    allow: "autoplay"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("a", {
        id: "expandClick",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickExpand && _ctx.clickExpand(...args)))
      }, "Click to view Tariffs")
    ]),
    _hoisted_4
  ]))
}